import { signedFetch } from './client';

export async function listRules(storeName: string) {
  return signedFetch('GET', `/stores/${storeName}/rules`);
}

export async function addRule(
  storeName: string,
  name: string,
  sourceEventType: string,
  target: { type: string; arn: string },
  targetEventType?: string
) {
  return signedFetch('POST', `/stores/${storeName}/rules`, {
    name,
    sourceEventType,
    target,
    targetEventType,
  });
}

export async function deleteRule(storeName: string, ruleId: string) {
  return signedFetch('DELETE', `/stores/${storeName}/rules/${ruleId}`);
}
